module.exports = "/static/assets/acc6c29b5eee67bc6b2aa85854d9bb3a.svg";